import React, { useEffect, useState } from 'react';
import { bool as boolType, oneOf, shape as shapeType, string as stringType, } from 'prop-types';
import { useDataModel } from '@thd-nucleus/data-sources';
import { ProductPod } from '@thd-olt-component-react/product-pod-v6';
import { Col } from '@thd-olt-component-react/core-ui';
import { useStore } from '@thd-nucleus/experience-context';
import useCxtPropsAndOptions from '../hooks/useCxtPropsAndOptions';
import VisuallySimilarDrawerRecommendations from './VisuallySimilarDrawerRecommendations';
import { dynamicRecsDataModel } from '../dataModel';
import { isLoading } from '../utils/helpers';
import '../../styles/thd-recs-containers.scss';

const VisuallySimilarDrawer = (props) => {

  const [isMounted, setIsMounted] = useState(false);
  const { storeId, storeZip: zipCode, membershipInformation } = useStore();
  useEffect(() => {
    setIsMounted(true);
  }, []);

  const {
    anchorId,
    schemaName,
    requestKey
  } = props;

  const { opts } = useCxtPropsAndOptions(anchorId, requestKey, schemaName, null, null);
  opts.variables.loyaltyMembershipInput = membershipInformation?.data?.loyaltyMembership || null;

  const { data, error, loading } = useDataModel('recs', opts);

  if (!isMounted || error || (!loading && !data?.recs)) {
    return null;
  }

  return (
    <Col id={schemaName} data-component="VisuallySimilarDrawer">
      <VisuallySimilarDrawerRecommendations
        recs={data?.recs}
        membershipInformation={membershipInformation}
        itemClass="fixed-item"
        loading={isLoading(data, loading)}
        schemaName={schemaName}
        storeId={storeId}
        zipCode={zipCode}
        // eslint-disable-next-line react/jsx-props-no-spreading
        {...props}
      />
    </Col>
  );
};

VisuallySimilarDrawer.dataModel = dynamicRecsDataModel;

VisuallySimilarDrawer.displayName = 'VisuallySimilarDrawer';

VisuallySimilarDrawer.propTypes = {
  ...ProductPod.propTypes,
  // eslint-disable-next-line react/forbid-prop-types
  schemaName: stringType,
  requestKey: stringType,

  // productPodProps
  // product-pod take only these values for brandTitleMaxLine prop
  brandTitleMaxLine: oneOf([2, 3, null]),
  customEventObject: shapeType({
    component: stringType,
    customEvent: stringType
  }),
  hideATC: boolType,
  hideBulkPrice: boolType,
  hideFavorites: boolType,
  hideFulfillment: boolType,
  hideLimitPerOrder: boolType,
  hidePriceBadge: boolType,
  hideRating: boolType,
  hideRebates: boolType,
  hideSavingsText: boolType,
  hideShopThisCollection: boolType,
  hideShippingInfo: boolType,
  showSubscribeAndSave: boolType,
  noATCFulfillment: boolType
};

VisuallySimilarDrawer.defaultProps = {
  schemaName: 'visuallysimilar_1_0',

  brandTitleMaxLine: null,
  customEventObject: null,
  hideATC: false,
  hideBulkPrice: false,
  requestKey: null,
  hideFavorites: true,
  hideFulfillment: true,
  hideLimitPerOrder: true,
  hidePriceBadge: true,
  hideRating: false,
  hideRebates: true,
  hideSavingsText: true,
  hideShopThisCollection: true,
  hideShippingInfo: true,
  showSubscribeAndSave: false,
  noATCFulfillment: true
};

export { VisuallySimilarDrawer };
